import "core-js/stable";
import "./shared/langSelect";
import "./shared/importFonts";
import "../styles/thd-turnstile.scss";
var turnstileForm = document.getElementById("turnstileForm");

// Invisible form fields
var inputOk = document.getElementById("inputOk");

// Buttons
var buttonContinue = document.getElementById("buttonContinue");
var tsHasError = false;
function submitForm() {
  inputOk.value = "clicked";
  turnstileForm.submit();
}
function tsErrorHandler(e) {
  tsHasError = true;
}
setTimeout(function () {
  if (tsHasError === false) {
    buttonContinue.classList.remove("invisible");
  }
}, 5000);
turnstileForm.addEventListener("submit", function (e) {
  e.preventDefault();
  e.stopPropagation();
  inputOk.value = "clicked";
  turnstileForm.submit();
});

// Add to global scope for captcha callback.
window.submitForm = submitForm;
window.tsErrorHandler = tsErrorHandler;